import React, { useState } from 'react';
import { db, auth } from './firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { userService } from './services/userService';

const ManualInputForm = ({ onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    '姓名': '',
    '公司名稱': '',
    '職位': '',
    '電話': '',
    'Email': '',
    '地址': '',
    '網站': '',
    'LinkedIn': '',
    'Facebook': '',
    'Twitter': ''
  });
  const [note, setNote] = useState('');
  const [saving, setSaving] = useState(false);

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!auth.currentUser) {
      alert('請先登入');
      return;
    }

    // 檢查掃描限制
    const canScanResult = await userService.canScan(auth.currentUser.uid, auth.currentUser.email);
    if (!canScanResult.allowed) {
      alert('您的掃描次數已達上限，請聯繫 info@anivance.io 升級帳戶');
      return;
    }

    // 檢查是否至少填寫了姓名或公司名稱
    if (!formData['姓名'] && !formData['公司名稱']) {
      alert('請至少填寫姓名或公司名稱');
      return;
    }

    setSaving(true);
    
    try {
      // 過濾空值
      const cleanedData = Object.fromEntries(
        Object.entries(formData).filter(([key, value]) => value.trim() !== '')
      );

      const dataToSave = {
        ...cleanedData,
        note: note.trim(),
        userId: auth.currentUser.uid,
        userEmail: auth.currentUser.email,
        userName: auth.currentUser.displayName || auth.currentUser.email,
        isManualInput: true,
        timestamp: serverTimestamp()
      };

      await addDoc(collection(db, 'businessCardsnotenew'), dataToSave);
      
      // 增加掃描次數
      await userService.incrementScanCount(auth.currentUser.uid);
      
      onSuccess();
      onClose();
    } catch (error) {
      console.error('儲存失敗:', error);
      alert('儲存失敗，請重試');
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h2>手動新增名片</h2>
          <button onClick={handleCancel} className="close-btn">✕</button>
        </div>
        
        <form onSubmit={handleSubmit} className="manual-form">
          <div className="form-grid">
            {Object.entries(formData).map(([field, value]) => (
              <div key={field} className="form-field">
                <label>{field}:</label>
                <input
                  type={field === 'Email' ? 'email' : field === '電話' ? 'tel' : 'text'}
                  value={value}
                  onChange={(e) => handleInputChange(field, e.target.value)}
                  className="form-input"
                  placeholder={`請輸入${field}`}
                />
              </div>
            ))}
          </div>
          
          <div className="note-section">
            <label>💭 備註 (合作意向或下一步行動):</label>
            <textarea
              value={note}
              onChange={(e) => setNote(e.target.value)}
              className="note-textarea"
              placeholder="例如：對其產品有興趣，下週安排會議討論合作可能性..."
              rows="3"
            />
          </div>
          
          <div className="form-actions">
            <button type="button" onClick={handleCancel} className="btn-cancel">
              取消
            </button>
            <button type="submit" disabled={saving} className="btn-save">
              {saving ? '儲存中...' : '儲存'}
            </button>
          </div>
        </form>
      </div>

      <style jsx="true">{`
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.7);
          backdrop-filter: blur(5px);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 2000;
          padding: 20px;
        }

        .modal-content {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(20px);
          border-radius: 24px;
          border: 1px solid rgba(255, 255, 255, 0.6);
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
          max-width: 700px;
          width: 100%;
          max-height: 90vh;
          overflow: hidden;
          display: flex;
          flex-direction: column;
        }

        .modal-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 24px 28px;
          border-bottom: 1px solid rgba(255, 255, 255, 0.3);
          background: rgba(255, 255, 255, 0.1);
        }

        .modal-header h2 {
          margin: 0;
          color: rgba(108, 99, 143, 0.9);
          font-size: 24px;
          font-weight: 600;
          background: linear-gradient(135deg, #3f51b5, #673ab7);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .close-btn {
          background: none;
          border: none;
          font-size: 20px;
          cursor: pointer;
          color: rgba(108, 99, 143, 0.6);
          padding: 8px;
          border-radius: 8px;
          transition: all 0.2s ease;
        }

        .close-btn:hover {
          background: rgba(255, 255, 255, 0.3);
          color: rgba(108, 99, 143, 0.9);
        }

        .manual-form {
          padding: 28px;
          overflow-y: auto;
          flex: 1;
        }

        .form-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 20px;
          margin-bottom: 24px;
        }

        .form-field {
          display: flex;
          flex-direction: column;
        }

        .form-field label {
          margin-bottom: 8px;
          color: rgba(108, 99, 143, 0.8);
          font-weight: 600;
          font-size: 14px;
        }

        .form-input {
          padding: 12px 16px;
          border: 1px solid rgba(255, 255, 255, 0.4);
          border-radius: 12px;
          background: rgba(255, 255, 255, 0.3);
          backdrop-filter: blur(10px);
          font-size: 14px;
          color: rgba(108, 99, 143, 0.9);
          transition: all 0.3s ease;
          box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.3);
        }

        .form-input:focus {
          outline: none;
          border-color: rgba(102, 126, 234, 0.6);
          background: rgba(255, 255, 255, 0.5);
          box-shadow: 
            0 0 0 3px rgba(102, 126, 234, 0.2),
            inset 0 1px 0 rgba(255, 255, 255, 0.5);
        }

        .note-section {
          margin-bottom: 24px;
        }

        .note-section label {
          display: block;
          margin-bottom: 8px;
          color: rgba(108, 99, 143, 0.8);
          font-weight: 600;
          font-size: 14px;
        }

        .note-textarea {
          width: 100%;
          padding: 12px 16px;
          border: 1px solid rgba(255, 255, 255, 0.4);
          border-radius: 12px;
          background: rgba(255, 255, 255, 0.3);
          backdrop-filter: blur(10px);
          font-size: 14px;
          color: rgba(108, 99, 143, 0.9);
          font-family: inherit;
          resize: vertical;
          min-height: 80px;
          transition: all 0.3s ease;
          box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.3);
          box-sizing: border-box;
        }

        .note-textarea:focus {
          outline: none;
          border-color: rgba(102, 126, 234, 0.6);
          background: rgba(255, 255, 255, 0.5);
          box-shadow: 
            0 0 0 3px rgba(102, 126, 234, 0.2),
            inset 0 1px 0 rgba(255, 255, 255, 0.5);
        }

        .form-actions {
          display: flex;
          gap: 16px;
          justify-content: flex-end;
          padding-top: 20px;
          border-top: 1px solid rgba(255, 255, 255, 0.3);
        }

        .btn-cancel, .btn-save {
          padding: 12px 24px;
          border-radius: 20px;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          border: none;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .btn-cancel {
          background: rgba(108, 117, 125, 0.8);
          color: white;
        }

        .btn-cancel:hover {
          background: rgba(108, 117, 125, 1);
          transform: translateY(-1px);
        }

        .btn-save {
          background: linear-gradient(135deg, #56ab2f 0%, #a8e6cf 100%);
          color: white;
          box-shadow: 0 4px 12px rgba(86, 171, 47, 0.3);
        }

        .btn-save:hover:not(:disabled) {
          transform: translateY(-1px);
          box-shadow: 0 6px 16px rgba(86, 171, 47, 0.4);
        }

        .btn-save:disabled {
          opacity: 0.6;
          cursor: not-allowed;
          transform: none;
        }

        @media (max-width: 768px) {
          .modal-content {
            max-height: 95vh;
            margin: 10px;
          }

          .form-grid {
            grid-template-columns: 1fr;
            gap: 16px;
          }

          .form-actions {
            flex-direction: column;
          }

          .btn-cancel, .btn-save {
            width: 100%;
          }
        }
      `}</style>
    </div>
  );
};

export default ManualInputForm;